module.exports = __webpack_public_path__ + "static/media/support_es.b022ed9d.txt";